// extracted by mini-css-extract-plugin
export default {"container":"NoOffers_container__l94m+","actionBar":"NoOffers_actionBar__EEPt7","text":"NoOffers_text__jby64","buttons":"NoOffers_buttons__kUGw1"};